export enum HvacVersion {
  ACTUAL = 'actual',
  FUTURE = 'future',
}
